import React from 'react';

import {ENVDefaultObj, POInfoObj} from './dataObj.js';
import {camelCaseTransformerFn} from './applicationFn.js';
import {mainRenderFn} from './mainRenderFn.js';

class Searchelector extends React.Component {
  constructor(props) {
    super(props);
    this.optionsActive = false;
  }
  componentWillMount () {
    this.updateENVFn(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.updateENVFn(nextProps);
  }
  render () {
    return mainRenderFn(this);
  }

  updateENVFn (source) {
    this.env = new ENVDefaultObj().env;
    Object.keys(source).map((entry) => {
      switch (entry)
      {
      case 'styleObj':
        Object.keys(source.styleObj).map((node_entry) => {
          this.env.styleObj[node_entry] = {};
          Object.keys(source.styleObj[node_entry]).map((style_entry) => {
            let camelCaseStyleName = camelCaseTransformerFn(style_entry);
            this.env.styleObj[node_entry][camelCaseStyleName] = source.styleObj[node_entry][style_entry];
          });
        });
        break;
      default:
        this.env[entry] = source[entry];
        break;
      }
    });

    this.printoutData = new POInfoObj(this.env['selectId']).printout;
  }
}

Searchelector.propTypes = {
  
};
Searchelector.defaultProps = {
  
};

export default Searchelector;
